export class BrowserStorageHelper {
    private static readonly JWT_KEY: string = 'VP_JWT';

    static saveJWT(jwt: string): void {
        window.localStorage.setItem(this.JWT_KEY, jwt);
    }

    static getJWT(): string | null {
        return window.localStorage.getItem(this.JWT_KEY);
    }

    static killSession(): void {
        window.localStorage.clear();
    }
}
